import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Select,
  DatePicker,
  Row,
  Col,
  Spin,
  Radio,
  Breadcrumb,
  Tooltip,
  Input,
  Modal,
} from "antd";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { Trans, useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { getRequest, patchRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import moment from "moment";
import dayjs from "dayjs";
import PRPopUpDetails from "../PR/PRPopUpDetails";
import { InfoCircleOutlined } from "@ant-design/icons";
import PurchaseRequisitionSteelDetails from "../PR/PurchaseRequisitionSteelDetails";
import PRPopUpDetailsForSteel from "../PR/PRPopUpDetailsForSteel";

const AddRFQ = () => {
  const [form] = Form.useForm();
  const initialState = {
    currency: 1,
    price_basis: "Firm",
    buying_pattern: "Unit Rate of Cement including Freight",
    unloading: "Buyer's Scope",
    transport_insurance: "Seller's Scope",
    remark_deviation: false,
    open_order: false,
    delivery_date: moment().add(7, "days").format("DD-MM-YY"),
    price_cap: null,
    amount_cap: "",
    delivery_start_date: null,
    delivery_end_date: null,
    rfq_due_date: moment()
      .add(2, "days")
      .set({ hour: 16, minute: 0 })
      .format("DD-MM-YY HH:mm"),
  };
  const [state, setState] = useState(initialState);
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { Option } = Select;
  const [prNumberHover, setPRNumberHover] = useState(null);
  const [prCreatorHover, setCreatorHover] = useState(null);
  const { responseId } = useParams();
  const formRef = useRef();
  const [currencyName, setCurrencyName] = useState([]);
  const [rfqNumber, setRfqNumber] = useState("");
  const [rfqEditId, setRfqEditId] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [prNumberList, setPRNumberList] = useState([]);
  const [prNumberd, setPrNumberd] = useState(null);
  const [statePRDetailsHover, setStatePRDetailsHover] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategoryName, setSelectedCategoryName] = useState(null);
  const [diameterWiseSteel, setDiameterWiseSteel] = useState([]);
  const [categoryTree, setCategoryTree] = useState("");

  useEffect(() => {
    if (state?.freight) {
      form.setFieldsValue({ freight: state.freight });
    }
  }, [state?.freight, form]);
  useEffect(() => {
    const rfqGetById = async () => {
      try {
        setapiLoading(true);
        const apiResponse = await getRequest(`float-rfq/${responseId}/`);
        const rfqDetails = apiResponse.data.data.rfq_details[0] || {};

        const defaultDate = moment()
          .add(2, "days")
          .set({ hour: 16, minute: 0 });

        if (apiResponse.data.success) {
          setCategoryTree(apiResponse.data.data.category_tree_name)
          setRfqNumber(apiResponse.data.data.rfq_number);
          setSelectedCategoryName(apiResponse.data.data.category_tree_name);
          setPRNumberList(
            apiResponse.data.data.purchase_requisition_city_by_pr_number
          );
          setPrNumberd(apiResponse.data.data.pr_creator_name);
          setDiameterWiseSteel(
            apiResponse.data.data.purchase_requisition_city_by_pr_number[0]
              .is_diameter_wise
          );
          if (apiResponse?.data?.data?.rfq_details.length !== 0) {
            setState((prevState) => ({
              ...prevState,
              currency:
                apiResponse.data.data.rfq_details[0]?.currency === null
                  ? 1
                  : apiResponse.data.data.rfq_details[0]?.currency,
              price_basis: apiResponse.data.data.rfq_details[0].price_basis,

              freight: apiResponse.data.data.rfq_details[0].freight,
              buying_pattern:
                apiResponse.data.data.rfq_details[0].buying_pattern,
              unloading: apiResponse.data.data.rfq_details[0].unloading,
              transport_insurance:
                apiResponse.data.data.rfq_details[0].transport_insurance,

              remark_deviation:
                apiResponse.data.data.rfq_details[0].remark_deviation,
              open_order: apiResponse.data.data.rfq_details[0].open_order,

              delivery_date: rfqDetails.delivery_date
                ? moment(rfqDetails.delivery_date, "DD-MM-YY").format(
                    "DD-MM-YY"
                  )
                : (rfqDetails.rfq_due_date
                    ? moment(rfqDetails.rfq_due_date, "DD-MM-YY HH:mm")
                    : moment()
                  )
                    .add(7, "days")
                    .format("DD-MM-YY"),

              price_cap: apiResponse.data.data.rfq_details[0].price_cap,
              amount_cap: apiResponse.data.data.rfq_details[0].amount_cap,
              delivery_start_date: rfqDetails.delivery_start_date
                ? moment(rfqDetails.delivery_start_date, "DD-MM-YY").format(
                    "DD-MM-YY"
                  )
                : null,
              delivery_end_date: rfqDetails.delivery_end_date
                ? moment(rfqDetails.delivery_end_date, "DD-MM-YY").format(
                    "DD-MM-YY"
                  )
                : null,
              rfq_due_date: rfqDetails.rfq_due_date
                ? moment(rfqDetails.rfq_due_date, "DD-MM-YY HH:mm")
                    .set({ hour: 16, minute: 0 })
                    .format("DD-MM-YY HH:mm")
                : moment()
                    .add(2, "days")
                    .set({ hour: 16, minute: 0 })
                    .format("DD-MM-YY HH:mm"),
            }));
          } else {
            setState((prevState) => ({
              ...prevState,
              freight:
                apiResponse.data.data?.buying_pattern ===
                "Unit Rate of Cement including Freight"
                  ? "Buyer's Scope"
                  : "Seller's Scope",
            }));
          }
          if (apiResponse.data.data.rfq_details[0].open_order === true) {
            setShowAdditionalFields(true);
            setDeliveryFields(false);
          } else {
            setShowAdditionalFields(false);
          }

          formRef.current.setFieldsValue({
            delivery_date: rfqDetails.delivery_date
              ? moment(rfqDetails.delivery_date, "DD-MM-YY")
              : (rfqDetails.rfq_due_date
                  ? moment(rfqDetails.rfq_due_date, "DD-MM-YY HH:mm")
                  : moment()
                ).add(7, "days"),
            currency:
              apiResponse.data.data.rfq_details[0].currency === null
                ? 1
                : apiResponse.data.data.rfq_details[0].currency,
            price_basis: apiResponse.data.data.rfq_details[0].price_basis,
            buying_pattern: apiResponse.data.data.rfq_details[0].buying_pattern,
            freight: rfqDetails
              ? apiResponse.data.data.rfq_details[0].freight
              : apiResponse.data.data?.buying_pattern ===
                "Unit Rate of Cement including Freight"
              ? "Buyer's Scope"
              : "Seller's Scope",
            unloading: apiResponse.data.data.rfq_details[0].unloading,
            transport_insurance:
              apiResponse.data.data.rfq_details[0].transport_insurance,
            remark_deviation:
              apiResponse.data.data.rfq_details[0].remark_deviation,

            open_order: apiResponse.data.data.rfq_details[0].open_order,
            amount_cap: apiResponse.data.data.rfq_details[0]
              ? parseInt(
                  apiResponse.data.data.rfq_details[0].amount_cap?.replace(
                    /[^\d]/g,
                    ""
                  ),
                  10
                ).toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                })
              : "",
            price_cap: apiResponse.data.data.rfq_details[0].price_cap,
            delivery_start_date: rfqDetails.delivery_start_date
              ? moment(rfqDetails.delivery_start_date, "DD-MM-YY")
              : null,
            delivery_end_date: rfqDetails.delivery_end_date
              ? moment(rfqDetails.delivery_end_date, "DD-MM-YY")
              : null,
            rfq_due_date: rfqDetails.rfq_due_date
              ? moment(rfqDetails.rfq_due_date, "DD-MM-YY HH:mm")
              : moment().add(2, "days").set({ hour: 16, minute: 0 }),
          });

          setRfqEditId(apiResponse?.data?.data?.rfq_details[0]?.id);

          setapiLoading(false);
        } else {
          ErrorNotificationMsg(t("error_in_rfq_detail"));
        }
      } catch (error) {
        setapiLoading(false);
      }
    };
    if (responseId !== null) {
      rfqGetById();
    }
  }, [responseId, t]);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const getCurrency = async (data) => {
    await getRequest("currency/", data).then((response) => {
      const allCurrency = response.data.results.data;

      const rupeeCurrency = allCurrency.filter(
        (item) => item.currency_code === "INR"
      );

      setCurrencyName(rupeeCurrency);
    });
  };

  useEffect(() => {
    getCurrency();
  }, [t]);

  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [showdeliveryFields, setDeliveryFields] = useState(true);

  const handleSelectChange = (name, value) => {
    if (name === "open_order") {
      setState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      if (value === true) {
        setShowAdditionalFields(true);
        setDeliveryFields(false);
      } else {
        setShowAdditionalFields(false);
        setDeliveryFields(true);
      }
    }
  };

  const handleSelectChangeUnloading = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const handleSelectChangePriceBasis = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const handleSelectChangefreight = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const handleDatepickerChange = (date, dateString, fieldName) => {
    setState({ ...state, [fieldName]: dateString ? dateString : null });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const rawValue = value.replace(/[^\d]/g, "");

    setState((prevState) => ({
      ...prevState,
      [name]: rawValue,
    }));
  };

  const rules = [{ required: true, message: "Amount Cap is required!" }];

  const handleOptionChange = (fieldName, value) => {
    setState((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }));
  };
  const handleSubmit = async () => {
    try {
      setBtnLoading(true);

      const payload1 = {
        currency: state.currency,
        price_basis: state.price_basis,
        freight: state.freight,
        unloading: state.unloading,
        transport_insurance: state.transport_insurance,
        remark_deviation: state.remark_deviation,
        open_order: state.open_order,
        delivery_date: null,
        price_cap: state.price_cap,
        amount_cap: state.amount_cap,
        delivery_start_date: state.delivery_start_date,
        delivery_end_date: state.delivery_end_date,
        rfq_due_date: state.rfq_due_date,
        buying_pattern: state.buying_pattern,
      };
      const payload2 = {
        currency: state.currency,
        price_basis: state.price_basis,
        freight: state.freight,
        unloading: state.unloading,
        transport_insurance: state.transport_insurance,
        remark_deviation: state.remark_deviation,
        open_order: state.open_order,
        delivery_date: state.delivery_date,
        price_cap: null,
        amount_cap: null,
        delivery_start_date: null,
        delivery_end_date: null,
        rfq_due_date: state.rfq_due_date,
        buying_pattern: state.buying_pattern,
      };
      const payload = state?.open_order ? payload1 : payload2;
      let apiResponse;
      if (rfqEditId === null) {
        apiResponse = await patchRequest(
          `float-rfq/${responseId}/rfq-details/`,
          payload
        );
        if (apiResponse.data.success) {
          SuccessNotificationMsg(t("add_rfq_succesfully"));
          setState(initialState);
          formRef.current.setFieldsValue(initialState);
          setBtnLoading(false);
          if (selectedCategoryName.toLowerCase().includes("steel")) {
            navigate(
              `/request-for-quotation/rfq-material-details-steel/${responseId}`
            );
          } else {
            navigate(
              `/request-for-quotation/rfq-material-details/${responseId}`
            );
          }
        }
      } else {
        apiResponse = await patchRequest(
          `float-rfq/${responseId}/rfq-details/${rfqEditId}/`,
          payload
        );
        if (apiResponse.data.success) {
          SuccessNotificationMsg(t("add_rfq_succesfully"));
          setState(initialState);
          formRef.current.setFieldsValue(initialState);
          setBtnLoading(false);
          // navigate(`/request-for-quotation/rfq-material-details/${responseId}`);
          if (selectedCategoryName.toLowerCase().includes("steel")) {
            navigate(
              `/request-for-quotation/rfq-material-details-steel/${responseId}`
            );
          } else {
            navigate(
              `/request-for-quotation/rfq-material-details/${responseId}`
            );
          }
        }
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };
  const disabledDeliveryDate = (current) => {
    const rfqDueDate = state?.rfq_due_date
      ? moment(state?.rfq_due_date, "DD-MM-YYYY hh:mm")
      : null;
    return current && current < rfqDueDate;
  };
  const disabledDeliveryEndDate = (current) => {
    const rfqDueDate = state?.delivery_start_date
      ? moment(state?.delivery_start_date, "DD-MM-YYYY")
      : null;
    return current && current < rfqDueDate;
  };
  const handleSelectChangeCurrency = (fieldName, value) => {
    setState((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }));
  };
  const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  const disabledDate = (current) => {
    return current && current < dayjs().endOf("day");
  };
  const disabledDateTime = () => ({
    disabledHours: () => range(0, 24).splice(4, 20),
    disabledMinutes: () => range(30, 60),
    disabledSeconds: () => [55, 56],
  });

  const disabledTime = () => ({
    disabledHours: () => [],
    disabledMinutes: () => [],
    disabledSeconds: () => [],
  });

  const handleDatepickerChange1 = (date, dateString, fieldName) => {
    setState({
      ...state,
      [fieldName]: dateString ? dateString : null,
      delivery_date: null,
    });
    formRef.current.setFieldsValue({
      delivery_date: null,
    });
    if (date && !dateString.includes(" ")) {
      dateString += "00:00";
      date = moment(dateString, "DD-MM-YYYY HH:mm");
    }
  };
  const handleDateStartpickerChange = (date, dateString, fieldName) => {
    setState({
      ...state,
      [fieldName]: dateString ? dateString : null,
      delivery_end_date: null,
    });
    formRef.current.setFieldsValue({
      delivery_end_date: null,
    });
    if (date && !dateString.includes(" ")) {
      dateString += " 00:00";
      date = moment(dateString, "DD-MM-YYYY HH:mm");
    }
  };

  const handleShowHoveredPRDetails = (prNumber, statePRDetails, creator) => {
    setPRNumberHover(prNumber);
    setCreatorHover(creator);
    setStatePRDetailsHover(statePRDetails);
    showModal();
  };

  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Manage and track requests for quotations (RFQs) for
                  procurement purposes.
                </span>
              }
            >
              <h3>Request For Quotation (RFQ)</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/add-rfq">
                  {t("pl_add_rfq")}
                </Link>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <h5 className="rfq-number new" style={{ alignItems: "center" }}>
            PR Number :{" "}
            {prNumberList.map((prNumber, index) => {
              return (
                <>
                  <span
                    key={index}
                    onMouseEnter={() => {
                      handleShowHoveredPRDetails(
                        prNumber?.pr_number,
                        prNumber?.data,
                        prNumber?.pr_creator
                      );
                    }}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {prNumber?.pr_number}
                    <InfoCircleOutlined
                      style={{
                        color: "#094E8F",
                        marginLeft: "3px",
                        background: "none",
                        paddingRight: "0",
                        padding: "0px",
                      }}
                    />
                  </span>
                </>
              );
            })}
          </h5>
        </div>
      </div>
      <section className="grid-sec FormSection mt-5">
        <div className="FormBody">
          <Spin spinning={apiLoading}>
            <Form
              onFinish={handleSubmit}
              autoComplete="off"
              ref={formRef}
              form={form}
            >
              <h5 className="rfq-number new">
                RFQ Number : <span>{rfqNumber}</span>
              </h5>

              <Row gutter={[15]}>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="currency"
                    label={t("pl_currency")}
                    prefix={<ZipCode />}
                    rules={[
                      {
                        required: true,
                        message: <Trans>Please Select Currency</Trans>,
                      },
                    ]}
                    initialValue={1}
                  >
                    <Select
                      showArrow
                      placeholder={t("pl_select_currency")}
                      onChange={(value) =>
                        handleSelectChangeCurrency("currency", value)
                      }
                      optionFilterProp="children"
                      defaultValue={1}
                    >
                      {currencyName.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {`${item.currency_name} ${item.currency_symbol}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="price_basis"
                    label={t("pl_price_basis")}
                    prefix={<ZipCode />}
                    rules={[
                      {
                        required: true,
                        message: <Trans>Please Select Price Basis</Trans>,
                      },
                    ]}
                    initialValue={state?.price_basis}
                  >
                    <Select
                      showArrow
                      placeholder={t("pl_select_price_basis")}
                      onChange={(value) =>
                        handleSelectChangePriceBasis("price_basis", value)
                      }
                      optionFilterProp="children"
                      defaultValue={"Firm"}
                    >
                      <Select.Option value="Firm">Firm</Select.Option>
                      <Select.Option value="Variable">Variable</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[15]}>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="freight"
                    label={t("pl_freight")}
                    rules={[
                      {
                        required: true,
                        message: <Trans>Please Select Freight</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      value={state?.freight}
                      placeholder={t("pl_select_freight")}
                      onChange={(value) => {
                        handleSelectChangefreight("freight", value);
                      }}
                    >
                      <Select.Option value="Seller's Scope">
                        Vendor Scope
                      </Select.Option>
                      <Select.Option value="Buyer's Scope">
                        Buyer Scope
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="transport_insurance"
                    label={t("pl_transist_insurance")}
                    initialValue={state?.transport_insurance || "Buyer's Scope"}
                  >
                    <Select
                      showArrow
                      optionFilterProp="children"
                      value={state?.transport_insurance || "Buyer's Scope"}
                      onChange={(value) =>
                        handleOptionChange("transport_insurance", value)
                      }
                    >
                      <Select.Option value="Seller's Scope">
                        Vendor Scope
                      </Select.Option>
                      <Select.Option value="Buyer's Scope">
                        Buyer Scope
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="unloading2"
                    label={t("pl_unloading")}
                    prefix={<ZipCode />}
                    rules={[
                      {
                        required: true,
                        message: <Trans>Please Select Unloading</Trans>,
                      },
                    ]}
                    initialValue={
                      state?.buying_pattern ===
                      "Unit Rate of Cement including Freight"
                        ? "Buyer's Scope"
                        : state?.unloading || "Buyer's Scope"
                    }
                  >
                    <Select
                      showArrow
                      placeholder={t("pl_unloading")}
                      onChange={(value) =>
                        handleSelectChangeUnloading("unloading", value)
                      }
                      optionFilterProp="children"
                      value={state?.unloading || "Buyer's Scope"}
                    >
                      <Select.Option value="Buyer's Scope">
                        Buyer Scope
                      </Select.Option>
                      <Select.Option value="Seller's Scope">
                        Vendor Scope
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[15]}>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    className="radioitem"
                    name="open_order"
                    label="Open Order"
                    initialValue={state?.open_order}
                  >
                    <Radio.Group
                      onChange={(e) =>
                        handleSelectChange("open_order", e.target.value)
                      }
                      value={state?.open_order}
                    >
                      <Radio value={true}>Yes</Radio>
                      <Radio value={false}>No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[15]}>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="rfq_due_date"
                    label="RFQ BID Due Date & Time"
                    dependencies={["rfq_due_date"]}
                    rules={[
                      {
                        validator(_, value) {
                          if (value || state?.rfq_due_date) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            <Trans>Please Select RFQ BID Due Date</Trans>
                          );
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      showTime={{
                        format: "HH:mm",
                        defaultValue: moment("16:00", "HH:mm"),
                      }}
                      format="DD-MM-YY HH:mm"
                      disabledDate={disabledDate}
                      disabledTime={disabledTime}
                      showNow={false}
                      defaultValue={moment()
                        .add(2, "days")
                        .set({ hour: 16, minute: 0 })}
                      value={
                        state?.rfq_due_date
                          ? moment(state?.rfq_due_date, "DD-MM-YY HH:mm")
                          : moment().add(2, "days").set({ hour: 16, minute: 0 })
                      }
                      onChange={(date, dateString) =>
                        handleDatepickerChange1(
                          date,
                          dateString,
                          "rfq_due_date"
                        )
                      }
                    />
                  </Form.Item>
                </Col>

                {showdeliveryFields && (
                  <Col
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="delivery_date"
                      label="Delivery Date"
                      dependencies={["delivery_date"]}
                      rules={[
                        {
                          validator(_, value) {
                            if (value || state?.delivery_date) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              <Trans>Please Select Delivery Date</Trans>
                            );
                          },
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YY"
                        disabledDate={disabledDeliveryDate}
                        disabled={state?.rfq_due_date === null}
                        showNow={false}
                        defaultValue={moment().add(7, "days")}
                        value={
                          state?.delivery_date
                            ? moment(state.delivery_date, "DD-MM-YY")
                            : moment().add(7, "days")
                        }
                        onChange={(date, dateString) =>
                          handleDatepickerChange(
                            date,
                            dateString,
                            "delivery_date"
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                )}
                {showAdditionalFields && (
                  <>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        label="Amount Cap (₹)"
                        name="amount_cap"
                        rules={rules}
                        normalize={(value) => {
                          const rawValue = value?.replace(/[^\d]/g, "");
                          return rawValue
                            ? parseInt(rawValue, 10).toLocaleString("en-IN", {
                                maximumFractionDigits: 0,
                              })
                            : "";
                        }}
                      >
                        <Input
                          prefix={<span>₹</span>}
                          name="amount_cap"
                          type="text"
                          value={state.amount_cap}
                          onChange={handleInputChange}
                          maxLength="20"
                          placeholder="Enter amount"
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name="delivery_start_date"
                        label="Delivery Start Date"
                        rules={[
                          {
                            required: true,
                            message: (
                              <Trans>Please Select Delivery Start Date</Trans>
                            ),
                          },
                        ]}
                      >
                        <DatePicker
                          format="DD-MM-YY"
                          disabledDate={disabledDeliveryDate}
                          disabledTime={disabledDateTime}
                          showNow={false}
                          onChange={(date, dateString) =>
                            handleDateStartpickerChange(
                              date,
                              dateString,
                              "delivery_start_date"
                            )
                          }
                          disabled={state?.rfq_due_date === null}
                          value={
                            state.delivery_start_date
                              ? moment(state.delivery_start_date, "DD-MM-YY")
                              : null
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name="delivery_end_date"
                        label="Delivery End Date"
                        rules={[
                          {
                            required: true,
                            message: (
                              <Trans>Please Select Delivery End Date</Trans>
                            ),
                          },
                        ]}
                      >
                        <DatePicker
                          format="DD-MM-YY"
                          disabledDate={disabledDeliveryEndDate}
                          disabledTime={disabledDateTime}
                          disabled={state?.delivery_start_date === null}
                          showNow={false}
                          onChange={(date, dateString) =>
                            handleDatepickerChange(
                              date,
                              dateString,
                              "delivery_end_date"
                            )
                          }
                          value={
                            state.delivery_end_date
                              ? moment(state.delivery_end_date, "DD-MM-YY")
                              : null
                          }
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}

                <div className="FormFooter Container">
                  <ButtonField
                    className="CancelGradiantBtn"
                    type="primary"
                    htmlType="Cancel"
                    label="Cancel"
                    onClick={() => navigate(`/request-for-quotation/history`)}
                  />
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="submit"
                    label="Save & Next"
                    loading={btnLoading}
                  />
                </div>
              </Row>
            </Form>
          </Spin>
        </div>
      </section>
      <Modal
        className="ModelPopupSecPopUpPRDetails"
        title={
          <div style={{ justifyItems: "center" }}>
            <h5 className="rfq-number new">
              PR Number : <span>{prNumberHover}</span>
              PR Creator : <span>{prCreatorHover}</span>
            </h5>
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={handleCancel}
        keyboard={true}
        width={"90%"}
      >
        {diameterWiseSteel ? (
          <PRPopUpDetailsForSteel prData={statePRDetailsHover} />
        ) : (
          <PRPopUpDetails statePRDetails={statePRDetailsHover} categoryTree={categoryTree} />
        )}
      </Modal>
    </>
  );
};

export default AddRFQ;
